(ns ballot-scout-v2-frontend.global-stats.subs
  (:require [re-frame.core :as rf]))

(rf/reg-sub
 ::ballot-stats
 (fn [db]
   (get-in db [:global-stats :ballot-stats])))

(rf/reg-sub
 ::dispo-stats
 (fn [db]
   (get-in db [:global-stats :dispo-stats])))

(rf/reg-sub
 ::election-stats
 (fn [db]
   (get-in db [:global-stats :election-stats])))

(rf/reg-sub
 ::subs-stats
 (fn [db]
   (get-in db [:global-stats :subs-stats])))

(rf/reg-sub
 ::notys-stats
 (fn [db]
   (get-in db [:global-stats :notys-stats])))

(rf/reg-sub
 ::usps-stats
 (fn [db]
   (get-in db [:global-stats :usps-stats])))
